import styles from "./ADSContentLeft.module.scss";
import ADSAddButton from "./Component/ADSAddButton";
import ADSGenerate from "./Component/ADSGenerate";
import PromptWizard from "../../../../../../../../Components/PromptWizard";
import ADSSelect from "./Component/ADSSelect";
import {
  AITools,
  CreditCostMap,
  FluxModel,
  // Ideogram3TurboColorPaletteOptions,
  // Ideogram3TurboStyleTypeOptions,
  // IdeogramColorPaletteOptions,
  // IdeogramModel,
  // IdeogramStyleTypeOptions,
  ImageAspectRatioOptions,
  ImageAspectRatioOptionsMap,
  ModelOptions,
  WeddinglyModel,
} from "../../../../constant";
import ADSInput from "./Component/ADSInput";
import { useADSContext } from "../../../../context/ADSProvider";
import { useMemo } from "react";
import ADSKeepStructure from "../../../ADSKeepStructure";
import { useAIToolsContext } from "../../../../context/AIToolsProvider";
import { useImageEditorContext } from "../../../../context/ImageEditorProvider";
// import ADSSelectColorPalette from "./Component/ADSSelectColorPalette";
import ADSChip from "./Component/ADSChip";
import ImageUpload from "../../../../../../../../Components/ImageUpload";
import { AIWeddingImageEditPlaceholder } from "../../../../../_HomeScreen/constans";

const ADSContentLeft = () => {
  const {
    form,
    setForm,
    isExternalModel,
    // isIdeogramModel,
    categories,
    loadingCategories,
    generalCategory,
    selectedProduct,
    userInfo,
    setOutOfCreditsModal,
    supportsAspectRatio,
  } = useADSContext();
  const { selectedAITools, firstSelectedImage } = useAIToolsContext();
  const { isEditingImage } = useImageEditorContext();

  const categoriesOptions = useMemo(
    () =>
      (categories || []).map((category) => ({
        value: category.id,
        label: category.name,
      })),
    [categories]
  );

  const isHighlightAndSwap =
    !!selectedAITools &&
    [AITools.HighlightAndSwap, AITools.HighlightAndSwap2].includes(
      selectedAITools
    );

  const countWords = (text) => {
    if (!text || text.trim() === "") {
      return 0;
    }
    return text.trim().split(/\s+/).length;
  };

  const disabledPromptWizard = useMemo(
    () =>
      (!!selectedAITools && !isHighlightAndSwap) ||
      isEditingImage ||
      countWords(form.prompt) <= 1,
    [form.prompt, isEditingImage, isHighlightAndSwap, selectedAITools]
  );
  const disabledPrompt = useMemo(() => {
    if (isHighlightAndSwap) {
      const imagePath =
        selectedProduct?.imageEditedUrl || selectedProduct?.imageUrl || null;

      return !imagePath && !firstSelectedImage;
    }

    return (!!selectedAITools && !isHighlightAndSwap) || isEditingImage;
  }, [
    firstSelectedImage,
    isEditingImage,
    isHighlightAndSwap,
    selectedAITools,
    selectedProduct?.imageEditedUrl,
    selectedProduct?.imageUrl,
  ]);

  const disabledModel = useMemo(
    () => !!selectedAITools || isEditingImage,
    [isEditingImage, selectedAITools]
  );
  const disabledCategory = useMemo(
    () => !!selectedAITools || isEditingImage,
    [isEditingImage, selectedAITools]
  );
  const disabledNegativePrompt = useMemo(
    () => !!selectedAITools || isEditingImage,
    [isEditingImage, selectedAITools]
  );
  const disableKeepStructure = useMemo(
    () => !!selectedAITools || isEditingImage,
    [isEditingImage, selectedAITools]
  );
  // const disableChip = useMemo(
  //   () => !!selectedAITools || isEditingImage,
  //   [isEditingImage, selectedAITools]
  // );
  // const disableColorPalette = useMemo(
  //   () => !!selectedAITools || isEditingImage,
  //   [isEditingImage, selectedAITools]
  // );

  const showUploadImage = useMemo(() => {
    return form.model === FluxModel.FluxKontext;
  }, [form.model]);

  const handleChangeModel = (model) => {
    const generateNewPrompt = (model, currentPrompt) => {
      if (
        model !== WeddinglyModel.StudioV2FullBody ||
        currentPrompt.startsWith("Full body.")
      ) {
        return currentPrompt;
      }

      return "Full body. " + currentPrompt;
    };

    const generateCategoryId = (generalCategory, currentCategoryId) => {
      if (!currentCategoryId) {
        return generalCategory.id || 0;
      }

      return currentCategoryId;
    };

    // Check for not enough credits
    const useCredit = CreditCostMap[model] || CreditCostMap.others;
    const { balance } = userInfo.userCredit || {};
    if (balance < useCredit) {
      // const isModalShown = sessionStorage.getItem(
      //   "adsChangeModelNotEnoughCreditsModalShown"
      // );
      // if (!isModalShown) {
      setOutOfCreditsModal({
        show: true,
        variant: "notEnoughCredits",
        reverseTitleColor: true,
      });
      // sessionStorage.setItem(
      //   "adsChangeModelNotEnoughCreditsModalShown",
      //   "true"
      // );
      // }
    }

    setForm((prev) => ({
      ...prev,
      model,
      categoryId: generateCategoryId(generalCategory, prev.categoryId),
      prompt: generateNewPrompt(model, prev.prompt),
    }));
  };

  const handleUploadImage = (imageInputFile) => {
    setForm((prev) => ({
      ...prev,
      selectedImageUrl: null,
      imageInputFile,
    }));
  };

  const handleChangeCategory = (categoryId) => {
    setForm((prev) => ({
      ...prev,
      categoryId,
    }));
  };

  const handleChangePrompt = (prompt) => {
    setForm((prev) => ({
      ...prev,
      prompt,
      originalPrompt: prompt,
    }));
  };

  const handleChangeNegativePrompt = (negativePrompt) => {
    setForm((prev) => ({
      ...prev,
      negativePrompt,
    }));
  };

  const handleChangeKeepStructure = (_e, keepStructure) => {
    setForm((prev) => ({
      ...prev,
      keepStructure,
    }));
  };

  const handleSelectWizardPrompt = (wizardPrompt) => {
    setForm((prev) => ({
      ...prev,
      prompt: wizardPrompt,
    }));
  };

  // const handleChangeIdeogramColorPalette = (colorPalette) => {
  //   setForm((prev) => ({
  //     ...prev,
  //     colorPalette,
  //   }));
  // };

  // const handleChangeStyleType = (styleType) => {
  //   setForm((prev) => ({
  //     ...prev,
  //     styleType,
  //   }));
  // };

  const handleChangeAspectRatio = (aspectRatio) => {
    if (form.aspectRatio === aspectRatio) {
      setForm((prev) => ({
        ...prev,
        aspectRatio: null,
      }));
      return;
    }

    setForm((prev) => ({
      ...prev,
      aspectRatio,
    }));
  };

  // const isIdeogram3TurboModel = useMemo(
  //   () => form.model === IdeogramModel.Ideogram3,
  //   [form.model]
  // );
  // const currentIdeogramStyleTypeOptions = useMemo(
  //   () =>
  //     isIdeogram3TurboModel
  //       ? Ideogram3TurboStyleTypeOptions
  //       : IdeogramStyleTypeOptions,
  //   [isIdeogram3TurboModel]
  // );
  // const currentIdeogramColorPaletteOptions = useMemo(
  //   () =>
  //     isIdeogram3TurboModel
  //       ? Ideogram3TurboColorPaletteOptions
  //       : IdeogramColorPaletteOptions,
  //   [isIdeogram3TurboModel]
  // );

  const placeholder = useMemo(() => {
    if (form.model === FluxModel.FluxKontext) {
      return AIWeddingImageEditPlaceholder[0].text;
    }

    return "Enter keywords or descriptions to specify what you want in the generated image.";
  }, [form.model]);

  // useEffect(() => {
  //   const isIdeogramStyleTypeNotInOptions =
  //     !currentIdeogramStyleTypeOptions.some(
  //       (option) => option.value === form.styleType
  //     );
  //   if (isIdeogramStyleTypeNotInOptions) {
  //     setForm((prev) => ({
  //       ...prev,
  //       styleType: "",
  //     }));
  //   }
  // }, [currentIdeogramStyleTypeOptions, form.model, form.styleType, setForm]);

  // useEffect(() => {
  //   const isIdeogramColorPaletteNotInOptions =
  //     !currentIdeogramColorPaletteOptions.some(
  //       (option) => option.value === form.colorPalette
  //     );
  //   if (isIdeogramColorPaletteNotInOptions) {
  //     setForm((prev) => ({
  //       ...prev,
  //       colorPalette: "",
  //     }));
  //   }
  // }, [
  //   currentIdeogramColorPaletteOptions,
  //   form.model,
  //   form.colorPalette,
  //   setForm,
  // ]);

  return (
    <div className={styles.wrapper}>
      {/* ACTIONS */}
      <section className={styles.actions}>
        <ADSAddButton />
        <ADSGenerate />
        <PromptWizard
          originalPrompt={form.originalPrompt}
          onSelectWizardPrompt={handleSelectWizardPrompt}
          disabled={disabledPromptWizard}
        />
      </section>

      {/* FORMS */}
      <section className={styles.forms}>
        {/* MODEL */}
        <ADSSelect
          value={form.model}
          options={ModelOptions}
          onChange={handleChangeModel}
          disabled={disabledModel}
          isModelSelection
        />

        {/* PROMPT */}
        <div style={{ position: "relative" }}>
          <ADSInput
            placeholder={placeholder}
            value={form.prompt}
            onChange={handleChangePrompt}
            disabled={disabledPrompt}
          />
        </div>

        {supportsAspectRatio && (
          <div style={{ display: "flex", gap: "6px" }}>
            {ImageAspectRatioOptions.map((option) => {
              const isActive = option.value === form.aspectRatio;
              return (
                <ADSChip
                  key={option.value}
                  label={option.label}
                  active={isActive}
                  onClick={() => handleChangeAspectRatio(option.value)}
                  withTooltip
                  aspectRatioSettings={ImageAspectRatioOptionsMap[option.value]}
                />
              );
            })}
          </div>
        )}

        {showUploadImage && (
          <ImageUpload
            disabled={disabledPrompt}
            onUpload={handleUploadImage}
            imageInputFile={form.imageInputFile}
            serverImageUrl={form.selectedImageUrl}
          />
        )}

        {/* Ideogram style type and color palette options hidden for now */}
        {/* {isIdeogramModel && (
          <>
            <div style={{ display: "flex", gap: "6px" }}>
              {currentIdeogramStyleTypeOptions.map((option) => {
                const isActive = option.value === form.styleType;
                return (
                  <ADSChip
                    key={option.value}
                    label={option.label}
                    active={isActive}
                    onClick={() => handleChangeStyleType(option.value)}
                    disabled={disableChip}
                  />
                );
              })}
            </div>

            <ADSSelectColorPalette
              value={form.colorPalette}
              options={currentIdeogramColorPaletteOptions}
              onChange={handleChangeIdeogramColorPalette}
              disabled={disableColorPalette}
            />
          </>
        )} */}

        {/* NEGATIVE PROMPT */}
        {!isExternalModel && (
          <ADSInput
            placeholder="Negative prompt: Add the negative prompt here. For example: blurry, dark, low quality, extra fingers."
            value={form.negativePrompt}
            onChange={handleChangeNegativePrompt}
            disabled={disabledNegativePrompt}
          />
        )}

        {/* KEEP STRUCTURE */}
        {!isExternalModel && (
          <ADSKeepStructure
            onChange={handleChangeKeepStructure}
            disabled={disableKeepStructure}
          />
        )}
      </section>
    </div>
  );
};

export default ADSContentLeft;
